import type { ReactNode } from 'react';

export const symbol_headset_mic: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-154q-24 0-42-18t-18-42v-304q0-74.73 28.5-140.88Q177-725.03 226-774.51 275-824 341.2-852.5q66.21-28.5 141-28.5 74.8 0 140.3 28.5Q688-824 736.05-774.51q48.05 49.48 76 115.63Q840-592.73 840-518v418q0 24-18 42t-42 18H512q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h268v-54h-88q-24.75 0-42.37-17.63Q632-189.25 632-214v-176q0-24.75 17.63-42.38Q667.25-450 692-450h88v-68q0-124-87-213.5T482-821q-124 0-213 89.5T180-518v68h88q24.75 0 42.38 17.62Q328-414.75 328-390v176q0 24.75-17.62 42.37Q292.75-154 268-154h-88Zm0-60h88v-176h-88v176Zm512 0h88v-176h-88v176ZM180-390h88-88Zm512 0h88-88Z"
		/>
	</svg>
);
